export const features = [
  {
    illustration: "/illustrations/automation.svg",
    title: "Smart Automation",
    description: "Automatically create and manage Pinterest boards based on your Shopify collections and tags."
  },
  {
    illustration: "/illustrations/ai-brain.svg",
    title: "AI-Powered Content",
    description: "Generate engaging descriptions and optimal hashtags using advanced AI technology."
  },
  {
    illustration: "/illustrations/sync.svg",
    title: "Real-time Sync",
    description: "Keep your pins updated automatically when products, prices, or inventory changes."
  },
  {
    illustration: "/illustrations/analytics.svg",
    title: "Performance Analytics",
    description: "Track engagement and optimize your Pinterest strategy with detailed insights."
  },
  {
    illustration: "/illustrations/schedule.svg",
    title: "Smart Scheduling",
    description: "Post at optimal times to maximize engagement and reach."
  },
  {
    illustration: "/illustrations/price-tag.svg",
    title: "Dynamic Pricing Updates",
    description: "Automatically reflect sales and discounts in your pins."
  }
]; 